import React from "react";
import moment from "moment";
import Error from "../error/error"

const updates = props => {
  let updateId = 0;

  let cardContent = <p>There are no updates to display.</p>;

  if (props.updates.error) cardContent = Error(props.updates.error);

  if (props.updates.completedActions.length > 0) {
    cardContent = props.updates.completedActions.map(update => {
      updateId++;
      const updateDate = moment(update.completedDate).format("DD/MM/YYYY");
      return (
        <mosaic-alert key={updateId} color="info">
          <mosaic-alert-text>
            <p>
              <strong>{update.description}</strong>
              <br />
              {updateDate}
            </p>
          </mosaic-alert-text>
        </mosaic-alert>
      );
    });
  }

  return (
    <mosaic-col xl="6">
      <mosaic-card id={props.cardName} fixed-height full-height>
        <mosaic-card-header title="Updates" />
        <mosaic-card-body>
          <div>{cardContent}</div>
        </mosaic-card-body>
      </mosaic-card>
    </mosaic-col>
  );
};

export default updates;
